export default __webpack_public_path__ + "static/media/img-6.9a45d473.jpg";